<template lang="html">

  <section class="index">

    <home-alumno v-if="isCandidato"></home-alumno>
    <home-empresa v-if="isEmpresa | !isLogged"></home-empresa>

  </section>

</template>

<script lang="js">

  import homealumno from '@/components/view-parts/home/home-alumno';

  import homeempresa from '@/components/view-parts/home/home-empresa';

  import { mapGetters, mapActions } from 'vuex';

  import router from '@/router';

  export default {
    name: 'home',
    mounted() {
      if (!!window.sessionStorage.getItem('pushto')) {
        setTimeout(e => {
          let pushto = window.sessionStorage.getItem('pushto');
          window.sessionStorage.removeItem('pushto');
          router.push(pushto);
        }, 200)
      }
    },
    components: {
      'home-alumno': homealumno,
      'home-empresa': homeempresa
    },
    computed: {
      ...mapGetters({
        isCandidato: 'isCandidato',
        isEmpresa: 'isEmpresa',
        isLogged: 'getLogged'
      })
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/views/home.vue